import { PolygonLayer } from "@deck.gl/layers"
import { ScanAreaData } from "features/entity-caching/flights/types"
import { getGlobalTerrainData } from "features/map/GlobalTerrainManager"
import { useAppSelector } from "integrations/redux/hooks"
import { selectInfraredScanAreaData } from "features/entity-caching/flights/selectors"

export const useIRScanAreaLayer = () => {
    const scanAreas = useAppSelector(selectInfraredScanAreaData())
    return new PolygonLayer<ScanAreaData>({
        id: "infrared-scan-areas",
        visible: true,
        data: scanAreas,
        getPolygon: (d) => {
            return d.coordinates.map((coord) => [coord.longitude, coord.latitude])
        },
        getFillColor: (d) => d.fillColor,
        getLineColor: (d) => d.outlineColor,
        pickable: true,
        lineWidthUnits: "pixels",
        getLineWidth: (d) => d.outlineThickness,
        extensions: [...getGlobalTerrainData().extensions],
    })
}
